import { useState } from 'react';
import { API } from '../../../../api/api';
import { URLS } from '../../../../api/urls';
import { Modal } from '../../../../components/Modal/Modal';
import { ALERT_TEXT } from '../../../../constants/content';
import { useAlert } from '../../../../context/Alert.context';
import { GadgetDto } from '../../../../types/gadgets.types';
import { GadgetEdit, GadgetSeoEdit } from '../../GadgetsPage.type';
import { GadgetForm } from './GadgetForm';

interface CreateGadgetModalProps {
  open: boolean;
  onClose: () => void;
  updateGadgetAfterCreate: (gadget: GadgetDto) => void;
}

export const CreateGadgetModal = ({
  open,
  onClose,
  updateGadgetAfterCreate,
}: CreateGadgetModalProps) => {
  const [loading, setLoading] = useState(false);
  const { showAlert } = useAlert();
  const create = async (data: GadgetEdit, seo: GadgetSeoEdit) => {
    try {
      setLoading(true);
      const formData = new FormData();
      data?.fileInfo && formData.append('fileInfo', data.fileInfo as File);
      formData.append('slug', data.slug || '');
      formData.append('name', data.name || '');
      formData.append('icon', data.icon || '');
      formData.append('faqPl', JSON.stringify(data.faqPl ?? []));
      formData.append('faqEn', JSON.stringify(data.faqEn ?? []));
      formData.append('faqUk', JSON.stringify(data.faqUk ?? []));
      formData.append('faqRu', JSON.stringify(data.faqRu ?? []));

      const { data: createdGadget } = await API.post(URLS.GADGETS, formData);

      updateGadgetAfterCreate(createdGadget);
      showAlert({
        message: ALERT_TEXT.GADGET_CREATED_SUCCESS,
        severity: 'success',
      });
      try {
        await API.post(URLS.GADGET_SEO, {
          gadgetId: createdGadget.id,
          ...seo,
        });

        showAlert({
          message: ALERT_TEXT.GADGET_SEO_EDIT_SUCCESS,
          severity: 'success',
        });
      } catch (e: any) {
        showAlert({
          message: e?.message ?? 'Failed to create gadget SEO',
          severity: 'error',
        });
      }
      onClose();
    } catch (e: any) {
      showAlert({
        message: e?.response?.data?.response ?? 'Failed to create gadget',
        severity: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal shouldPreventModal title="Add gadget" open={open} onClose={onClose}>
      <GadgetForm
        loading={loading}
        onSubmit={create}
        onCancel={onClose}
      />
    </Modal>
  );
};
